import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

const defaultInfoText = '';
const ViewDetails = ({ confirmData, confirmDataHandle }) => {
    const txt = window.allData?.
        modules[2]?.data?.articleList[0]?.summary || defaultInfoText;

    useEffect(() => {
        if (!confirmData.isClosePopup) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.position = '';
        }

    }, [confirmData]);

    return !confirmData.isClosePopup ? (
        <div className={styles.confirm}>
            <div className={styles.confirmBox}>
                <div className={styles.confirmTitle}>
                    <div dangerouslySetInnerHTML={{ __html: txt.replace(/\n/gi, '<br>') }} />
                    <div className={styles.space_100} />
                </div>
                <div className={styles.confirmOperate}>
                    <div
                        className={styles.confirmYes}
                        onClick={() => {
                            confirmDataHandle({ isClickOk: false, isCheck: true, isClosePopup: true });
                        }}>
                        不同意
                    </div>
                    <div
                        className={styles.confirmCancel}
                        onClick={() => {
                            confirmDataHandle({ isClickOk: true, isCheck: false, isClosePopup: true });
                        }}>
                        我同意
                    </div>
                </div>
                <div
                    className={styles.confirmClose}
                    onClick={() => {
                        confirmDataHandle({
                            ...confirmData,
                            isClosePopup: true
                        });
                    }}
                />
            </div>
        </div>
    ) : null;
};

ViewDetails.propTypes = {
    confirmData: PropTypes.object,
    confirmDataHandle: PropTypes.func,
};

export default errorBoundary(ViewDetails);
